export default "__VITE_ASSET__hH8XA24T__"